import { render } from "./Index.vue?vue&type=template&id=778e33cb&scoped=true"
import script from "./Index.vue?vue&type=script&lang=ts"
export * from "./Index.vue?vue&type=script&lang=ts"

import "./Index.vue?vue&type=style&index=0&id=778e33cb&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-778e33cb"

export default script